import { AddTask } from "@mui/icons-material";
import { Box, Button, Card, CardHeader, Divider, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { CreateTaskItemModal, ViewToggleButtonGroup } from "src/components";
import { useBreakpoints, useSession } from "src/hooks";
import { UserTaskItemsFilterButton, UserTaskItemsList } from "src/pages/UserPages/UserImplementationPage/components";
import { useUserImplementationSettings } from "src/pages/UserPages/UserImplementationPage/hooks";

interface Props {
  userGuid: string;
}

const UserTasksAgendaStep = (props: Props) => {
  const { userId: sessionUserGuid } = useSession();
  const { isMdUp } = useBreakpoints();
  const { settings, updateSettings } = useUserImplementationSettings(props.userGuid);
  const [isTableView, setIsTableView] = useState(true);
  const [isCreateTaskItemModalOpen, setIsCreateTaskItemModalOpen] = useState(false);

  useEffect(() => {
    handleViewToggled(settings.tableView);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.userGuid]);

  useEffect(() => {
    if (isMdUp) {
      setIsTableView(settings.tableView);
    } else {
      setIsTableView(false);
    }
  }, [isMdUp, props.userGuid, settings]);

  function handleViewToggled(value: boolean) {
    setIsTableView(value);
    updateSettings({
      tableView: value,
    });
  }

  return (
    <>
      <Card>
        <CardHeader
          title={<Typography variant="h6">Tasks</Typography>}
          action={
            <Stack direction="row" spacing={1} divider={<Divider orientation="vertical" flexItem />}>
              {props.userGuid === sessionUserGuid && (
                <Button variant="tertiary" startIcon={<AddTask />} onClick={() => setIsCreateTaskItemModalOpen(true)}>
                  Add New Task
                </Button>
              )}

              <Stack direction="row" spacing={1}>
                <UserTaskItemsFilterButton userGuid={props.userGuid} />
                {isMdUp && (
                  <ViewToggleButtonGroup
                    variant="tertiary"
                    isTableView={isTableView}
                    onViewToggled={handleViewToggled}
                    fontSize="small"
                  />
                )}
              </Stack>
            </Stack>
          }
          sx={{ pb: 0, pr: 0.5 }}
        />
        <Box sx={{ p: 0.5 }}>
          <UserTaskItemsList userGuid={props.userGuid} isTableView={isTableView} />
        </Box>
      </Card>

      <CreateTaskItemModal
        visible={isCreateTaskItemModalOpen}
        onCreated={() => setIsCreateTaskItemModalOpen(false)}
        onCancelled={() => setIsCreateTaskItemModalOpen(false)}
      />
    </>
  );
};

export { UserTasksAgendaStep };
